// Copyright (C) 2022 TANNER AG

import React from "react";
import Stack from "@mui/material/Stack";
import GroupAttr from "../GroupAttr";
import { formatBytes } from "../../lib/utils";
import FiletypeIcon from "../icons/FiletypeIcon";
import ListItemBase from "./ListItemBase";
import useDatetime from "../../hooks/usedatetime";

type Props = {
    id: string;
    name?: string;
    mime?: string;
    size?: number;
    modified?: string;
    action?: React.ReactNode;
    border?: boolean;
    inactive?: boolean;
};

const ListItemDownload: React.FC<Props> = ({ id, name, mime = "", size, inactive, modified, action, border }) => {
    const { fDate } = useDatetime();
    return (
        <ListItemBase
            id={id}
            name={name}
            action={action}
            border={border}
            inactive={inactive}
            icon={<FiletypeIcon filetype={mime} color="secondary" sx={{ fontSize: { xs: 34, sm: 40 } }} />}
        >
            <Stack direction="row" spacing={4}>
                <GroupAttr label={mime.toUpperCase()} value={formatBytes(size, 0)} minWidth="auto" />
                {modified && <GroupAttr label="Last updated" value={fDate(modified)} minWidth="auto" />}
            </Stack>
        </ListItemBase>
    );
};

export default ListItemDownload;
